import { Injectable } from "@angular/core";
import {
  DeleteTagResponse, TagDependencyEntry,
  TagRepository,
  UpdateTagResponse
} from '../../../domain/tag-repository';
import { HttpService } from "../../http/http";
import { TagMapper } from "./tag.mapper";
import { Tag } from "../../../domain/tag";
import { TagGroup } from "../../../domain/tag-group";
import { Logger } from "../../logger";
import { Subject } from "rxjs";

@Injectable()
export class CachedTagRepositoryImpl implements TagRepository {
  private generalTags: Tag[];
  private assetTypeTags: Tag[];
  private dayPartingTags: Tag[];

  generalTagCreated = new Subject<Tag>();

  constructor(
    private httpService: HttpService,
    private tagMapper: TagMapper,
    private logger: Logger,
  ) {}

  init() {
    return this.getAllGroups().then((groups) => this.extractTags(groups));
  }

  getGeneralTags() {
    return this.generalTags.slice(0);
  }

  getAssetTypeTags() {
    return this.assetTypeTags.slice(0);
  }

  getDayPartingTags() {
    return this.dayPartingTags.slice(0);
  }

  CreateGeneralTag(tagName: string) {
    return this.httpService
      .post(
        "Tag/AddToGroup",
        this.tagMapper.mapCreateGeneralTagRequest(tagName),
      )
      .then(this.tagMapper.mapCreateGeneralTagResponse)
      .then((createdTag) => {
        this.generalTags.push(createdTag);

        this.generalTagCreated.next(createdTag);
        return createdTag;
      });
  }

  Update(tag: Tag): Promise<UpdateTagResponse> {
    return this.httpService.patch(`Tag`, {
      Id: tag.id,
      Name: tag.name
    })
      .then(result => {
        console.log('tag-repository->Update', tag, result);
        if (result.IsSuccess) {
          this.generalTags.find(t => t.id === tag.id).name = tag.name;
        }
        return new UpdateTagResponse(result.IsSuccess, result.Dependencies ? result.Dependencies.map(x => new TagDependencyEntry(x.SourceType,x.SourceName)) : null);
      })
      .catch(resultError => {
        console.log('tag-repository->Delete->catch', tag, resultError);
        return new UpdateTagResponse(false);

      });
  }

  Delete(tag: Tag): Promise<DeleteTagResponse> {
    return this.httpService.delete(`Tag?tagId=${tag.id}`)
      .then(result => {
        console.log('tag-repository->Delete', tag, result);
        if (result.IsSuccess) {
          this.generalTags = this.generalTags.filter(x => x.id !== tag.id);
        }
        return new DeleteTagResponse(result.IsSuccess, result.Dependencies ? result.Dependencies.map(x => new TagDependencyEntry(x.SourceType,x.SourceName)) : null);
      })
      .catch(resultError => {
        console.log('tag-repository->Delete->catch', tag, resultError);
        return new DeleteTagResponse(false);

      });
  }

  private extractTags(tagGroups: TagGroup[]) {
    tagGroups.forEach((tagGroup) => {
      switch (tagGroup.name) {
        case "GENERAL":
          this.generalTags = tagGroup.tags;
          break;
        case "DAYPARTING":
          this.dayPartingTags = tagGroup.tags;
          break;
        case "ASSET TYPE":
          this.assetTypeTags = tagGroup.tags;
          break;
      }
    });

    if (!this.generalTags || !this.assetTypeTags || !this.dayPartingTags) {
      this.logger.warn(
        `extractTags=> one or more tag groups not found: generalTags:
${!!this.generalTags}; assetTypeTags: ${!!this.assetTypeTags}; dayPartingTags: ${!!this.dayPartingTags}`,
      );

      this.generalTags = this.generalTags || [];
      this.assetTypeTags = this.assetTypeTags || [];
      this.dayPartingTags = this.dayPartingTags || [];
    }
  }

  private getAllGroups(): Promise<TagGroup[]> {
    return this.httpService
      .get("Tag")
      .then(this.tagMapper.mapGetAllTagsResponse);
  }
}
